export enum PaymentProcessor {
  FINIX = "FINIX",
  STRIPE = "STRIPE",
  RAINFOREST = "RAINFOREST",
}

export interface SignUpFormData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  consentGiven: boolean;
}

export interface SignedPreviewResponse {
  signedUrl: string;
}
